module.exports = __webpack_public_path__ + "media/images/official-6-d11bda7d2900376d090147ec1168229a.png";